

//import axios from '@/axios.js'
import $axios from '@/axios.js'

export default {
  fetchDataListItems ({ commit }) {
    return new Promise((resolve, reject) => {
      $axios.get('/menu-list')
        .then((response) => {
          commit('SET_MENUS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  addItem ({ commit }, item ) {
    return new Promise((resolve, reject) => {
      $axios.post('/menu-add', item)
        .then((response) => {
          commit('ADD_ITEM', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      $axios.post(`/menu-update/${item.id}`, item)
        .then((response) => {
          commit('UPDATE_PRODUCT', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      $axios.delete(`/menu-delete/${itemId}`)
        .then((response) => {
          commit('REMOVE_ITEM', itemId)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  }
  // eventDragged({ commit }, payload) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`/api/apps/calendar/event/dragged/${payload.event.id}`, {payload: payload})
  //       .then((response) => {

  //         // Convert Date String to Date Object
  //         let event = response.data
  //         event.startDate = new Date(event.startDate)
  //         event.endDate = new Date(event.endDate)

  //         commit('UPDATE_EVENT', event)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
}
